// extracted by mini-css-extract-plugin
module.exports = {"nameColumn":"_1E1e0","nameContainer":"_3aEmO","row":"hSHoR","total":"_3jPgk","overflow":"_5T_Gw","tooltip":"_3unEY","divider":"_2f9w8"};